var map = {
	"./numbershape_01.json": "d1e6",
	"./numbershape_02.json": "d4ee",
	"./numbershape_1.json": "23b8",
	"./numbershape_10.json": "f7f1",
	"./numbershape_11.json": "56b26",
	"./numbershape_14.json": "9373",
	"./numbershape_18.json": "cc4a",
	"./numbershape_2.json": "3bce",
	"./numbershape_3.json": "32c2",
	"./numbershape_34.json": "9844",
	"./numbershape_4.json": "c18e",
	"./numbershape_42.json": "d941",
	"./numbershape_44.json": "070f",
	"./numbershape_48.json": "ffb7",
	"./numbershape_5.json": "b112",
	"./numbershape_6.json": "9003",
	"./numbershape_7.json": "eb9a",
	"./numbershape_8.json": "490c",
	"./numbershape_87.json": "1efb",
	"./numbershape_88.json": "8fba",
	"./numbershape_9.json": "b448",
	"./numbershape_circle_frame.json": "dd4a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5ccd";